import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  wcaCreateBotFlow,
  wcaGetAllBotFlows,
  wcaGetBotFlowSchema,
  wcaPublishBotFlow,
  wcaSaveBotFlowSchema,
  wcaUpdateBotFlowDetails,
} from '../../../api/wca/wca.botflow.services';

const getErrorPayload = (error) => error?.response?.data || error?.message || error;

const isSchemaNotFoundError = (error) => {
  const statusCode = error?.statusCode || error?.status || error?.errorCode;
  return statusCode === 404;
};

export const addBotFlowSteps = createAsyncThunk(
  'wcaBotFlow/addBotFlow',
  async ({ id, botFlowSteps }, thunkAPI) => {
    try {
      const response = await wcaPublishBotFlow(id, botFlowSteps);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorPayload(error));
    }
  },
);

export const getBotFlow = createAsyncThunk('wcaBotFlow/getBotFlow', async (id, thunkAPI) => {
  try {
    const response = await wcaGetBotFlowSchema(id);
    return response;
  } catch (error) {
    const errorPayload = getErrorPayload(error);

    if (isSchemaNotFoundError(errorPayload)) {
      return {
        flowId: id,
        nodes: [],
        edges: [],
        rootStepId: null,
        _schemaNotFound: true,
      };
    }

    return thunkAPI.rejectWithValue(errorPayload);
  }
});

export const updateBotFlow = createAsyncThunk(
  'wcaBotFlow/updateBotFlow',
  async ({ id, botFlowData }, thunkAPI) => {
    try {
      const response = await wcaSaveBotFlowSchema(id, botFlowData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorPayload(error));
    }
  },
);

export const getAllBotFlow = createAsyncThunk(
  'wcaBotFlow/getAllBotFlow',
  async ({ page, limit }, thunkAPI) => {
    try {
      const response = await wcaGetAllBotFlows(page, limit);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorPayload(error));
    }
  },
);

export const updateBotflowDetails = createAsyncThunk(
  'wcaBotFlow/updateBotflowDetails',
  async ({ id, updatedData }, thunkAPI) => {
    try {
      const response = await wcaUpdateBotFlowDetails(id, updatedData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorPayload(error));
    }
  },
);

export const deleteBotflow = createAsyncThunk(
  'wcaBotFlow/deleteBotflow',
  async (id, thunkAPI) => {
    try {
      await wcaUpdateBotFlowDetails(id, { isActive: false });
      return { id };
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorPayload(error));
    }
  },
);

export const addNewBotFlow = createAsyncThunk(
  'wcaBotFlow/addNewBotflow',
  async (botflowPayload, thunkAPI) => {
    try {
      const response = await wcaCreateBotFlow(botflowPayload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorPayload(error));
    }
  },
);
